import i18next from 'i18next';
import { Languages } from 'infrastructure/enums';

export interface ILanguageItem {
  id: Languages | null;
  name: string;
}

export const languagesDataSource = (
  englishSpanishOnly = false,
  withAll = false,
): ILanguageItem[] => {
  let languages: ILanguageItem[] = (
    Object.keys(Languages) as Array<keyof typeof Languages>
  ).map((langugae) => ({
    id: Languages[langugae],
    name: i18next.t(`languages.${Languages[langugae]}`),
  }));

  if (englishSpanishOnly) {
    languages = languages.filter(
      (language) =>
        language.id === Languages.En || language.id === Languages.Es,
    );
  }

  if (withAll) {
    languages.unshift({
      id: null,
      name: i18next.t('states.All'),
    });
  }

  return languages;
};
